export const MINI_SIZE = 70;
export const GAP = 10;
export const ITEM_WIDTH = MINI_SIZE + GAP;
